<template>
  <div class="cabinet-content-container">
    <div class="content">
      <div class="cabinet-header">
        <h4> Available Cabinets </h4>
        <DxButton text="New Cabinet"
                  icon="add"
                  type="default"
                  :width="150"
                  :height="40"
                  @click="cabinetsPageStore.setOpenNewCabinetPopup(true)"
        />
      </div>
      <CabinetsGrid/>
       <NewCabinetPopup v-model:visible="openNewCabinetPopup" @close-popup="cabinetsPageStore.setOpenNewCabinetPopup(false)"/>
       <TryNewVersionPopup v-model:visible="showTryNewVersion"/>
    </div>
  </div>
</template>

<script setup>
  import { ref } from "vue"
  import CabinetsGrid from "@/components/cabinets-page/CabinetsGrid.vue";
  import NewCabinetPopup from "@/components/cabinets-page/NewCabinetPopup.vue";
  import TryNewVersionPopup from "@/components/cabinets-page/TryNewVersionPopup.vue";
  import { DxButton } from "devextreme-vue";
  import { storeToRefs } from 'pinia';
  import { useCabinetsPageStore } from "@/stores/cabinetsPageStore.js";
  import { shouldPromptPreferV3 } from "@/js-modules/preferV3.js";

  const cabinetsPageStore = useCabinetsPageStore()
  const { openNewCabinetPopup } = storeToRefs(cabinetsPageStore)
  const showTryNewVersion = ref(shouldPromptPreferV3())

  cabinetsPageStore.getCabinetList()
</script>

<style scoped lang="scss">
  .cabinet-content-container {
    display: flex;
    justify-content: center;
    padding: 1.25rem;
    background-color: $white-normal;

    .content {
      display: flex;
      flex-direction: column;
      max-width: 65rem;

      .cabinet-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
</style>
